import type {
  ContentItemDraft,
  ContentItemType,
  Locale,
  PageContent,
  PageMeta,
  PageSection,
  PageSectionProps,
  PageTemplateDefinition,
  PageTemplateKey,
  SectionFieldKey,
  SectionVariant,
  SiteSettings,
  ThemeDefinition,
  ThemeKey,
  ThemeSectionDefinition,
  ThemeTemplateKey,
} from "./model";
import { entryDefaults, pageMetaDefaults, sectionPropsDefaults, themeSettingsDefaults } from "./themeContent";

export const PAGE_TEMPLATES: PageTemplateDefinition[] = [
  { key: "home", label: { tr: "Ana sayfa", en: "Homepage" }, description: "Temanın eksiksiz Porto ana sayfa düzeni.", sectionVariants: [] },
  { key: "standard", label: { tr: "Standart / detay", en: "Standard / detail" }, description: "Hakkımızda ve kurumsal içerik sayfaları.", sectionVariants: [] },
  { key: "catalog", label: { tr: "Katalog listesi", en: "Catalog listing" }, description: "Hizmet ve kurumsal katalog kayıtlarını listeler.", sectionVariants: [] },
  { key: "news", label: { tr: "Haber listesi", en: "News listing" }, description: "Haber ve blog kayıtlarını listeler.", sectionVariants: [] },
  { key: "contact", label: { tr: "İletişim", en: "Contact" }, description: "İletişim bilgileri, form ve Turnstile.", sectionVariants: [] },
];

export const THEMES: Record<ThemeKey, ThemeDefinition> = {
  "creative-agency-2": {
    key: "creative-agency-2",
    name: "Creative Agency 2",
    description: "Yaratıcı ajanslar ve dijital stüdyolar için güçlü portfolyo sunumu.",
    primaryColor: "#f74b54",
    secondaryColor: "#171717",
    heroImage: "/porto/img/demos/creative-agency-2/backgrounds/background-1.jpg",
    cssFile: "/porto/css/demos/demo-creative-agency-2.css",
    skinFile: "/porto/css/skins/skin-creative-agency-2.css",
    pages: [
      page("home", "Ana Sayfa", "Home", "", "", "/porto/img/demos/creative-agency-2/concept/concept-1.jpg", "home"),
      page("about", "Hakkımızda", "About Us", "hakkimizda", "about-us", "/porto/img/demos/creative-agency-2/concept/concept-2.jpg", "standard"),
      page("services", "Hizmetler", "Services", "hizmetler", "services", "/porto/img/demos/creative-agency-2/services/services-1.jpg", "catalog"),
      page("news", "Haberler", "News", "haberler", "news", "/porto/img/demos/creative-agency-2/concept/concept-3.jpg", "news"),
      page("contact", "İletişim", "Contact", "iletisim", "contact", "/porto/img/demos/creative-agency-2/concept/concept-3.jpg", "contact"),
    ],
    collections: [],
  },
  "accounting-1": {
    key: "accounting-1",
    name: "Accounting 1",
    description: "Muhasebe, finans ve kurumsal danışmanlık şirketleri için kapsamlı yapı.",
    primaryColor: "#4be296",
    secondaryColor: "#263238",
    heroImage: "/porto/img/demos/accounting-1/slides/slide-2.jpg",
    cssFile: "/porto/css/demos/demo-accounting-1.css",
    skinFile: "/porto/css/skins/skin-accounting-1.css",
    pages: [
      page("home", "Ana Sayfa", "Home", "", "", "/porto/img/demos/accounting-1/slides/slide-2.jpg", "home"),
      page("about", "Hakkımızda", "About", "hakkimizda", "about", "/porto/img/demos/accounting-1/generic/generic-1.jpg", "standard"),
      page("services", "Hizmetler", "Services", "hizmetler", "services", "/porto/img/demos/accounting-1/services/service-1.jpg", "catalog"),
      page("news", "Haberler", "News", "haberler", "news", "/porto/img/demos/accounting-1/blog/blog-post-1.jpg", "news"),
      page("contact", "İletişim", "Contact", "iletisim", "contact", "/porto/img/demos/accounting-1/bg/bg-2.jpg", "contact"),
    ],
    collections: [],
  },
  "business-consulting-3": {
    key: "business-consulting-3",
    name: "Business Consulting 3",
    description: "Yönetim ve iş danışmanlığı firmaları için modern kurumsal tema.",
    primaryColor: "#e2a300",
    secondaryColor: "#14213d",
    heroImage: "/porto/img/demos/business-consulting-3/backgrounds/background-1.jpg",
    cssFile: "/porto/css/demos/demo-business-consulting-3.css",
    skinFile: "/porto/css/skins/skin-business-consulting-3.css",
    pages: [
      page("home", "Ana Sayfa", "Home", "", "", "/porto/img/demos/business-consulting-3/backgrounds/background-1.jpg", "home"),
      page("about", "Hakkımızda", "About", "hakkimizda", "about", "/porto/img/demos/business-consulting-3/generic/generic-1.jpg", "standard"),
      page("services", "Hizmetler", "Services", "hizmetler", "services", "/porto/img/demos/business-consulting-3/services/services-1.jpg", "catalog"),
      page("news", "Blog", "Blog", "blog", "blog", "/porto/img/demos/business-consulting-3/blog/blog-1.jpg", "news"),
      page("contact", "İletişim", "Contact", "iletisim", "contact", "/porto/img/demos/business-consulting-3/backgrounds/background-4.jpg", "contact"),
    ],
    collections: [],
  },
  "transportation-logistic": {
    key: "transportation-logistic",
    name: "Transportation Logistic",
    description: "Güvenlik, lojistik ve saha hizmet firmaları için Porto transportation teması.",
    primaryColor: "#099fdc",
    secondaryColor: "#0b6afb",
    heroImage: "/porto/img/demos/transportation-logistic/slides/slide-1.jpg",
    cssFile: "/porto/css/demos/demo-transportation-logistic.css",
    skinFile: "/porto/css/skins/skin-transportation-logistic.css",
    pages: [
      page("home", "Ana Sayfa", "Home", "", "", "/porto/img/demos/transportation-logistic/slides/slide-1.jpg", "home"),
      page("about", "Kurumsal", "Corporate", "kurumsal", "corporate", "/porto/img/demos/transportation-logistic/generic/generic-1.png", "standard"),
      page("services", "Çözümlerimiz", "Solutions", "cozumlerimiz", "solutions", "/porto/img/demos/transportation-logistic/services/service-1.jpg", "catalog"),
      page("news", "Haberler", "News", "haberler", "news", "/porto/img/demos/transportation-logistic/blog/post-thumb-1.jpg", "news"),
      page("contact", "İletişim", "Contact", "iletisim", "contact", "/porto/img/demos/transportation-logistic/generic/generic-2.jpg", "contact"),
    ],
    collections: [],
  },
};

const PORTO_FILES: Record<ThemeKey, Partial<Record<ThemeTemplateKey, string>>> = {
  "accounting-1": {
    home: "demo-accounting-1.html",
    standard: "demo-accounting-1-about.html",
    catalog: "demo-accounting-1-services.html",
    news: "demo-accounting-1-news.html",
    contact: "demo-accounting-1-contact.html",
    "service-detail": "demo-accounting-1-services-details.html",
    "news-post": "demo-accounting-1-news-post.html",
  },
  "creative-agency-2": {
    home: "demo-creative-agency-2.html",
    standard: "demo-creative-agency-2-about-us.html",
    catalog: "demo-creative-agency-2-services.html",
    news: "demo-creative-agency-2.html",
    contact: "demo-creative-agency-2-contact-us.html",
    "service-detail": "demo-creative-agency-2-services.html",
    "news-post": "demo-creative-agency-2.html",
  },
  "business-consulting-3": {
    home: "demo-business-consulting-3.html",
    standard: "demo-business-consulting-3-about.html",
    catalog: "demo-business-consulting-3-services.html",
    news: "demo-business-consulting-3-blog.html",
    contact: "demo-business-consulting-3-contact.html",
    "service-detail": "demo-business-consulting-3-services-detail.html",
    "news-post": "demo-business-consulting-3-blog-post.html",
  },
  "transportation-logistic": {
    home: "demo-transportation-logistic.html",
    standard: "demo-transportation-logistic-about-us.html",
    catalog: "demo-transportation-logistic-services.html",
    news: "demo-transportation-logistic-news.html",
    contact: "demo-transportation-logistic-contact-us.html",
    "service-detail": "demo-transportation-logistic-news-post.html",
    "news-post": "demo-transportation-logistic-news-post.html",
  },
};

function page(key: string, trLabel: string, enLabel: string, trSlug: string, enSlug: string, image: string, templateKey: PageTemplateKey) {
  return { key, label: { tr: trLabel, en: enLabel }, slug: { tr: trSlug, en: enSlug }, image, templateKey };
}

type DefinitionInput = [string, string, string, SectionVariant, SectionFieldKey[], boolean?, boolean?];

function definitions(themeKey: ThemeKey, home: DefinitionInput[]): ThemeSectionDefinition[] {
  const prefix = themeKey.split("-")[0]!;
  const map = (entry: DefinitionInput, templates: PageTemplateKey[]): ThemeSectionDefinition => ({
    key: entry[0], label: { tr: entry[1], en: entry[2] },
    description: { tr: `${entry[1]} içeriğini yönetin.`, en: `Manage ${entry[2].toLowerCase()} content.` },
    templates, renderVariant: entry[3], fields: entry[4], singleton: entry[5] ?? true, required: entry[6] ?? false,
    imageHint: entry[4].includes("image") ? "1920 × 900 px, WebP önerilir" : undefined,
  });
  const common: Array<[DefinitionInput, PageTemplateKey[]]> = [
    [[`${prefix}-page-intro`, "Sayfa tanıtımı", "Page introduction", "split", ["eyebrow", "title", "text", "image"]], ["standard", "catalog", "news"]],
    [[`${prefix}-content`, "İçerik alanı", "Content section", "split", ["eyebrow", "title", "text", "image", "button"], false], ["standard"]],
    [[`${prefix}-catalog-grid`, "Katalog kayıtları", "Catalog entries", "cards", ["eyebrow", "title", "text"]], ["catalog"]],
    [[`${prefix}-news-grid`, "Haber kayıtları", "News entries", "cards", ["eyebrow", "title", "text"]], ["news"]],
    [[`${prefix}-contact-form`, "İletişim ve form", "Contact and form", "split", ["eyebrow", "title", "text", "image"], true, true], ["contact"]],
    [[`${prefix}-cta`, "İletişim çağrısı", "Contact callout", "cta", ["title", "text", "button"], false], ["standard", "catalog", "news"]],
  ];
  return [...home.map((entry) => map(entry, ["home"])), ...common.map(([entry, templates]) => map(entry, templates))];
}

const contentFields: SectionFieldKey[] = ["eyebrow", "title", "text", "image", "button"];
const listFields: SectionFieldKey[] = ["eyebrow", "title", "text", "items"];

export const THEME_SECTION_DEFINITIONS: Record<ThemeKey, ThemeSectionDefinition[]> = {
  "accounting-1": definitions("accounting-1", [
    ["accounting-hero", "Ana slider", "Main slider", "gallery", contentFields, true, true],
    ["accounting-feature-strip", "Özellik şeridi", "Feature strip", "feature-grid", listFields],
    ["accounting-intro", "Firma tanıtımı", "Company introduction", "split", [...contentFields, "items"]],
    ["accounting-services", "Hizmetler", "Services", "cards", listFields],
    ["accounting-why-us", "Neden biz?", "Why choose us", "feature-grid", listFields],
    ["accounting-expertise", "Uzmanlık alanları", "Expertise", "split", contentFields],
    ["accounting-stats", "İstatistikler", "Statistics", "stats", ["eyebrow", "title", "items"]],
    ["accounting-testimonials", "Müşteri yorumları", "Testimonials", "quote", listFields],
    ["accounting-cta", "Güçlü çağrı alanı", "Primary callout", "cta", ["title", "text", "button"]],
    ["accounting-quote-form", "Teklif formu", "Quote form", "split", contentFields],
    ["accounting-marquee", "Marka şeridi", "Brand marquee", "gallery", ["title", "items"]],
    ["accounting-latest-news", "Son haberler", "Latest news", "cards", ["eyebrow", "title", "text"]],
  ]),
  "creative-agency-2": definitions("creative-agency-2", [
    ["creative-hero", "Ana slider", "Main hero", "gallery", contentFields, true, true],
    ["creative-project-grid", "Proje grid’i", "Project grid", "gallery", listFields],
    ["creative-concept", "Concept ve hizmetler", "Concept and services", "feature-grid", listFields],
    ["creative-toggles", "Açılır içerikler", "Toggle content", "faq", listFields],
    ["creative-about", "Hakkımızda", "About", "split", [...contentFields, "items"]],
    ["creative-numbers", "Sayılarla ajans", "Agency in numbers", "stats", ["eyebrow", "title", "items"]],
  ]),
  "business-consulting-3": definitions("business-consulting-3", [
    ["consulting-hero", "Ana slider", "Main hero", "gallery", contentFields, true, true],
    ["consulting-highlights", "Hizmet özetleri", "Service highlights", "feature-grid", listFields],
    ["consulting-visual-strip", "Görsel şerit", "Visual strip", "gallery", ["image", "items"]],
    ["consulting-services", "Hizmetler", "Services", "cards", listFields],
    ["consulting-benefits", "Faydalar ve neden biz", "Benefits and why us", "feature-grid", listFields],
    ["consulting-skills", "Yetkinlikler", "Skills", "stats", listFields],
    ["consulting-team", "Ekip", "Team", "cards", listFields],
    ["consulting-cta", "İletişim çağrısı", "Contact callout", "cta", ["eyebrow", "title", "text", "button"]],
    ["consulting-testimonials", "Referanslar", "Testimonials", "quote", listFields],
    ["consulting-blog", "Son haberler", "Latest news", "cards", ["eyebrow", "title", "text"]],
  ]),
  "transportation-logistic": definitions("transportation-logistic", [
    ["transportation-hero", "Ana slider", "Main slider", "gallery", contentFields, true, true],
    ["transportation-services", "Çözüm şeridi", "Solutions strip", "cards", listFields],
    ["transportation-intro", "Firma tanıtımı", "Company introduction", "split", [...contentFields, "items"]],
    ["transportation-why", "Neden biz", "Why us", "feature-grid", listFields],
    ["transportation-process", "Süreç", "Process", "feature-grid", listFields],
    ["transportation-testimonials", "Referanslar", "Testimonials", "quote", listFields],
    ["transportation-cta", "Teklif çağrısı", "Quote callout", "cta", ["title", "text", "button"]],
    ["transportation-news", "Son haberler", "Latest news", "cards", ["eyebrow", "title", "text"]],
    ["transportation-faq", "SSS", "FAQ", "faq", listFields],
  ]),
};

export function getSectionDefinitions(themeKey: ThemeKey, templateKey: PageTemplateKey): ThemeSectionDefinition[] {
  return THEME_SECTION_DEFINITIONS[themeKey].filter((definition) => definition.templates.includes(templateKey));
}

export function portoFileFor(themeKey: ThemeKey, templateKey: ThemeTemplateKey): string {
  return PORTO_FILES[themeKey][templateKey] ?? PORTO_FILES[themeKey].home!;
}

export function templateIdFor(themeKey: ThemeKey, templateKey: ThemeTemplateKey): string {
  return `${themeKey}:${templateKey}`;
}

function defaultProps(themeKey: ThemeKey, locale: Locale, label: string, image: string): PageSectionProps {
  const tr = locale === "tr";
  return {
    eyebrow: tr ? "Sizi ileri taşıyan çözümler" : "Solutions that move you forward",
    title: label,
    text: tr ? "Bu alanın içeriğini yönetim panelinden kolayca düzenleyebilirsiniz." : "You can easily edit this section from the management panel.",
    image: image || THEMES[themeKey].heroImage,
    imageAlt: label,
    buttonLabel: tr ? "Detayları inceleyin" : "View details",
    buttonUrl: "#",
    items: Array.from({ length: 3 }, (_, index) => ({
      id: `${index + 1}`,
      title: tr ? `${label} ${index + 1}` : `${label} ${index + 1}`,
      text: tr ? "Kısa ve anlaşılır açıklama." : "A short and clear description.",
      image: image || THEMES[themeKey].heroImage,
    })),
  };
}

export function createDefaultSection(themeKey: ThemeKey, sectionKey: string, locale: Locale, order: number): PageSection {
  const definition = THEME_SECTION_DEFINITIONS[themeKey].find((item) => item.key === sectionKey);
  if (!definition) throw new Error(`Unknown section ${sectionKey}`);
  const theme = THEMES[themeKey];
  const curated = sectionPropsDefaults(themeKey, sectionKey, locale);
  return {
    id: crypto.randomUUID(), sectionKey, visible: true, order,
    props: curated ?? defaultProps(themeKey, locale, definition.label[locale], theme.heroImage),
  };
}

export function createDefaultSettings(themeKey: ThemeKey, locale: Locale, tenantName: string): SiteSettings {
  const theme = THEMES[themeKey];
  const curated = themeSettingsDefaults(themeKey, locale, tenantName);
  const tr = locale === "tr";
  return {
    siteName: curated.siteName ?? tenantName,
    tagline: curated.tagline ?? (tr ? "İşinizi birlikte büyütelim" : "Let us grow your business together"),
    heroTitle: curated.heroTitle ?? (tr ? `${tenantName} ile yeni bir başlangıç` : `A new beginning with ${tenantName}`),
    heroText: curated.heroText ?? (tr ? "Markanızı öne çıkaran, güven veren ve sonuç üreten çözümler sunuyoruz." : "We deliver trusted, result-driven solutions that make your brand stand out."),
    ctaLabel: curated.ctaLabel ?? (tr ? "Bizimle İletişime Geçin" : "Contact Us"),
    ctaUrl: curated.ctaUrl ?? (tr ? "iletisim" : "contact"),
    phone: curated.phone ?? "+90 212 000 00 00",
    email: curated.email ?? "info@example.com",
    address: curated.address ?? (tr ? "İstanbul, Türkiye" : "Istanbul, Türkiye"),
    primaryColor: curated.primaryColor ?? theme.primaryColor,
    secondaryColor: curated.secondaryColor ?? theme.secondaryColor,
    accentColor: theme.primaryColor,
    bodyColor: "#5d6470",
    headingColor: theme.secondaryColor,
    logoUrl: "",
    faviconUrl: "",
    fontFamily: themeKey === "creative-agency-2" ? "poppins" : "inter",
    borderRadius: themeKey === "accounting-1" ? "rounded" : themeKey === "creative-agency-2" ? "square" : "soft",
    buttonStyle: themeKey === "accounting-1" ? "pill" : "soft",
    headerStyle: themeKey === "creative-agency-2" ? "overlay" : "solid",
    contentWidth: "wide",
    seoTitle: curated.seoTitle ?? tenantName,
    seoDescription: curated.seoDescription ?? (tr ? `${tenantName} kurumsal web sitesi.` : `${tenantName} corporate website.`),
    seoKeywords: curated.seoKeywords ?? (tr ? "kurumsal, hizmetler, danışmanlık" : "corporate, services, consulting"),
    sitemapEnabled: true,
    robotsEnabled: true,
    robotsContent: "",
    llmsEnabled: true,
    llmsContent: "",
  };
}

export function createDefaultPageMeta(themeKey: ThemeKey, pageKey: string, locale: Locale): PageMeta {
  const definition = THEMES[themeKey].pages.find((candidate) => candidate.key === pageKey);
  if (!definition) throw new Error(`Unknown page ${pageKey}`);
  const tr = locale === "tr";
  const curated = pageMetaDefaults(themeKey, pageKey, locale);
  return {
    title: curated?.title ?? definition.label[locale],
    navLabel: curated?.navLabel ?? definition.label[locale],
    showInMenu: true,
    eyebrow: curated?.eyebrow ?? (tr ? "Sizi ileri taşıyan çözümler" : "Solutions that move you forward"),
    body: curated?.body ?? (tr ? `${definition.label.tr} sayfasının içeriğini yönetim panelinden kolayca düzenleyebilirsiniz.` : `You can easily edit the ${definition.label.en} page content from the management panel.`),
    heroImage: definition.image,
    heroStyle: definition.templateKey === "home" ? "overlay" : themeKey === "accounting-1" ? "split" : "image",
    visible: true,
    seoTitle: curated?.seoTitle ?? "",
    seoDescription: curated?.seoDescription ?? "",
  };
}

export function createDefaultPage(themeKey: ThemeKey, pageKey: string, locale: Locale): PageContent {
  const definition = THEMES[themeKey].pages.find((candidate) => candidate.key === pageKey);
  if (!definition) throw new Error(`Unknown page ${pageKey}`);
  const meta = createDefaultPageMeta(themeKey, pageKey, locale);
  const sectionDefinitions = getSectionDefinitions(themeKey, definition.templateKey);
  return {
    templateKey: definition.templateKey,
    slug: definition.slug[locale],
    ...meta,
    sections: sectionDefinitions.map((item, index) => createDefaultSection(themeKey, item.key, locale, index)),
  };
}

export function createCustomPage(themeKey: ThemeKey, locale: Locale, input: { title: string; slug: string; templateKey: PageTemplateKey }): PageContent {
  const definitions = getSectionDefinitions(themeKey, input.templateKey);
  const tr = locale === "tr";
  return {
    templateKey: input.templateKey, slug: input.slug, navLabel: input.title, showInMenu: true, title: input.title,
    eyebrow: tr ? "Yeni sayfa" : "New page", body: tr ? "Bu sayfanın içeriğini düzenleyin." : "Edit this page content.",
    heroImage: THEMES[themeKey].heroImage, heroStyle: input.templateKey === "home" ? "overlay" : "image", visible: true,
    sections: definitions.map((item, index) => createDefaultSection(themeKey, item.key, locale, index)), seoTitle: "", seoDescription: "",
  };
}

export function pageContentToMeta(content: PageContent): PageMeta {
  return {
    title: content.title,
    navLabel: content.navLabel,
    showInMenu: content.showInMenu,
    eyebrow: content.eyebrow,
    body: content.body,
    heroImage: content.heroImage,
    heroStyle: content.heroStyle,
    visible: content.visible,
    seoTitle: content.seoTitle ?? "",
    seoDescription: content.seoDescription ?? "",
  };
}

export function normalizePageContent(themeKey: ThemeKey, pageKey: string, locale: Locale, value: unknown): PageContent {
  const theme = THEMES[themeKey];
  const definition = theme.pages.find((item) => item.key === pageKey);
  const source = value && typeof value === "object" ? value as Partial<PageContent> & { templateKey?: unknown; sections?: unknown[] } : {};
  const templateKey = (["home", "standard", "catalog", "news", "contact"] as const).includes(source.templateKey as PageTemplateKey)
    ? source.templateKey as PageTemplateKey
    : definition?.templateKey ?? "standard";
  const base = definition ? createDefaultPage(themeKey, pageKey, locale) : createCustomPage(themeKey, locale, { title: source.title || pageKey, slug: source.slug || pageKey, templateKey });
  const allowed = getSectionDefinitions(themeKey, templateKey);
  const rawSections = Array.isArray(source.sections) ? source.sections : base.sections;
  const sections = rawSections.map((raw, index) => {
    const section = raw && typeof raw === "object" ? raw as unknown as Record<string, unknown> : {};
    const sectionKey = typeof section.sectionKey === "string" ? section.sectionKey : allowed[index]?.key ?? allowed[0]?.key;
    if (!sectionKey) return null;
    const fallback = createDefaultSection(themeKey, sectionKey, locale, index);
    const props = section.props && typeof section.props === "object" ? section.props as Partial<PageSectionProps> : {};
    return {
      id: typeof section.id === "string" ? section.id : crypto.randomUUID(), sectionKey,
      visible: section.visible !== false, order: typeof section.order === "number" ? section.order : index,
      props: {
        ...fallback.props, ...props,
        eyebrow: String(props.eyebrow ?? section.eyebrow ?? fallback.props.eyebrow),
        title: String(props.title ?? section.title ?? fallback.props.title), text: String(props.text ?? section.text ?? fallback.props.text),
        image: String(props.image ?? section.image ?? fallback.props.image), imageAlt: String(props.imageAlt ?? fallback.props.imageAlt),
        buttonLabel: String(props.buttonLabel ?? section.buttonLabel ?? fallback.props.buttonLabel), buttonUrl: String(props.buttonUrl ?? section.buttonUrl ?? fallback.props.buttonUrl),
        items: (Array.isArray(props.items) ? props.items : fallback.props.items) as PageSectionProps["items"],
      },
    } satisfies PageSection;
  }).filter((item): item is PageSection => Boolean(item)).sort((a, b) => a.order - b.order);
  return { ...base, ...source, templateKey, sections, slug: typeof source.slug === "string" ? source.slug : base.slug, navLabel: typeof source.navLabel === "string" ? source.navLabel : source.title ?? base.navLabel, showInMenu: typeof source.showInMenu === "boolean" ? source.showInMenu : base.showInMenu, heroStyle: source.heroStyle ?? base.heroStyle } as PageContent;
}

export function createDefaultContentItem(themeKey: ThemeKey, locale: Locale, itemType: ContentItemType, index: number): ContentItemDraft {
  const curated = entryDefaults(themeKey, locale, itemType, index);
  if (curated) return { ...curated };
  const tr = locale === "tr";
  const theme = THEMES[themeKey];
  const noun = itemType === "catalog" ? (tr ? "Hizmet" : "Service") : (tr ? "Haber" : "News");
  const slug = itemType === "catalog" ? (tr ? `hizmet-${index + 1}` : `service-${index + 1}`) : (tr ? `haber-${index + 1}` : `news-${index + 1}`);
  return {
    title: `${noun} ${index + 1}`, slug, category: itemType === "catalog" ? (tr ? "Hizmetler" : "Services") : (tr ? "Kurumsal" : "Corporate"),
    excerpt: tr ? "Bu kaydın kısa açıklamasını yönetim panelinden düzenleyebilirsiniz." : "Edit this entry summary from the management panel.",
    body: tr ? "Detay içeriğini burada zengin ve anlaşılır biçimde anlatın." : "Describe the detailed content clearly here.",
    coverImage: theme.pages.find((pageDef) => pageDef.templateKey === (itemType === "catalog" ? "catalog" : "news"))?.image ?? theme.heroImage,
    coverImageAlt: `${noun} ${index + 1}`, gallery: [], ctaLabel: tr ? "İletişime geçin" : "Contact us", ctaUrl: tr ? "/tr/iletisim" : "/en/contact",
    author: itemType === "news" ? (tr ? "Editör" : "Editor") : "", publishedOn: new Date().toISOString().slice(0, 10), seoTitle: "", seoDescription: "", visible: true,
  };
}

export function defaultContentItemCount(themeKey: ThemeKey, locale: Locale, itemType: ContentItemType): number {
  let index = 0;
  while (entryDefaults(themeKey, locale, itemType, index)) index += 1;
  return Math.max(index, 3);
}

export function sectionsForTemplate(themeKey: ThemeKey, templateKey: PageTemplateKey, locale: Locale, previous: PageSection[] = []): PageSection[] {
  const allowed = getSectionDefinitions(themeKey, templateKey);
  return allowed.map((definition, index) => {
    const existing = previous.find((section) => section.sectionKey === definition.key);
    if (existing) return { ...existing, order: index };
    return createDefaultSection(themeKey, definition.key, locale, index);
  });
}
